import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import PrimarySearchAppBar from "../components/PrimarySearchAppBar";
import { useAuth0 } from "@auth0/auth0-react";
import { ResultJSON } from '../components/ResultJSON';
import { FIPOKSurvey } from '../components/FIPOKSurvey';
import { Domains } from '../Utils';


export const SurveyPage = () => {
	const auth0Obj = useAuth0();
	const isAuthenticated = auth0Obj.isAuthenticated;
	const navigate = useNavigate();

	const { symbolicId } = useParams() as { symbolicId: string };

	const handleBackClick = () => {
		navigate(`/surveys`);
	};

	return (
		<div className="app-container">
			<div className="content">
				<PrimarySearchAppBar />
				<div className="content-inner">
					{!isAuthenticated && (
						<Box>
							A tartalom megtekintéséhez be kell jelentkeznie.
							You are not authenticated. Log in to see the contents.
						</Box>
					)}
					{isAuthenticated && (
						<ResultJSON bucketBaseURL={Domains.gamesURL} code={`./surveys/${symbolicId}`}>
							<div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', padding: '16px' }}>
								<span onClick={handleBackClick}><u>Visszalépés</u></span>
							</div>
							<FIPOKSurvey survey_id={symbolicId} />
						</ResultJSON>
					)}
				</div>
			</div>
		</div>
	);
};
